import * as ReactDOM from 'react-dom';
import { usePortal } from './usePortal';
export var Portal = function (_a) {
    var id = _a.id, children = _a.children;
    var target = usePortal(id);
    return ReactDOM.createPortal(children, target);
};
//# sourceMappingURL=Portal.js.map